export default "__VITE_ASSET__b53d98a5__"